import { BookingDetailsPanel } from '../../../sites/components/panel/organisms/BookingDetailsPanel';

interface VariationDrawerContentProps {
  variationId: string;
  potStatus?: string;
}

export function VariationDrawerContent({
  variationId,
  potStatus,
}: VariationDrawerContentProps) {
  return (
    <BookingDetailsPanel variationId={variationId} potStatus={potStatus} />
  );
}
